import axiosInstance from '@/services/axiosInstance'

async function unlinkAgrupacionProveedor (data) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve()
    })
  } else {
    const req = {
      url: 'api/sociedad/unlinkAgrupacionProveedor',
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { unlinkAgrupacionProveedor }
